import { Box, Typography, Button } from '@mui/material'
import logo from '../../assets/rounded_logo.svg'

export default function ProspectScreeningFrame() {
  return (
    <Box sx={{
      position: 'relative',
      width: 280,
      height: 560,
      bgcolor: '#000',
      borderRadius: 6,
      p: 1,
      boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
    }}>
      {/* iPhone Frame */}
      <Box sx={{
        width: '100%',
        height: '100%',
        bgcolor: 'white',
        borderRadius: 5,
        overflow: 'hidden',
        position: 'relative'
      }}>
        {/* Status Bar */}
        <Box sx={{
          height: 44,
          bgcolor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 2,
          fontSize: '0.875rem',
          fontWeight: 600
        }}>
          <Box
            component="img"
            src={logo}
            alt="HeyProperty"
            sx={{
              height: 40,
              width: 'auto',
              maxWidth: '60px',
              marginTop: '5px'
            }}
          />
        </Box>

        {/* Prospect Screening Content */}
        <Box sx={{ p: 3, textAlign: 'center', height: 'calc(100% - 44px)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography sx={{
            fontSize: '0.875rem',
            color: 'grey.600',
            mb: 4
          }}>
            Work or Study - Section 3 of 4
          </Typography>

          <Typography sx={{
            fontWeight: 700,
            fontSize: '1.125rem',
            color: 'grey.900',
            mb: 6
          }}>
            Are you currently employed?
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mb: 6 }}>
            <Button
              fullWidth
              variant="outlined"
              sx={{
                borderColor: 'grey.300',
                color: 'grey.600',
                textTransform: 'none',
                fontWeight: 600,
                py: 2,
                bgcolor: 'grey.50'
              }}
            >
              Yes
            </Button>
            <Button
              fullWidth
              variant="outlined"
              sx={{
                borderColor: 'grey.300',
                color: 'grey.600',
                textTransform: 'none',
                fontWeight: 600,
                py: 2,
                bgcolor: 'grey.50'
              }}
            >
              No
            </Button>
          </Box>
        </Box>

        {/* Home Indicator */}
        <Box sx={{
          position: 'absolute',
          bottom: 8,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 134,
          height: 5,
          bgcolor: '#000',
          borderRadius: 3
        }} />
      </Box>
    </Box>
  )
}
